module.exports = __webpack_public_path__ + "img/guihua-1.86ec1415.jpg";